import {querystringConfig} from '@/Constant';
import queryString from 'query-string';

export const addSourceToUrl = (url: string, isAdd: boolean, query: {[index: string]: any}) => {
    if (isAdd) {
        return queryString.stringifyUrl({
            url,
            query,
        }, querystringConfig);
    }
    return url;
};
